/**
 * “Forward this to whoever pays” — mailto / WhatsApp share.
 * Copy facts come from Express managerOnePager. Do not invent a journey
 * from featureId. No card form; chef picks the recipient.
 */

import {
  hasGrowthEngineUpgradeTone,
  isPaidGrowthEnginePlan,
  sanitizeGrowthEngineWhatsAppLabel,
} from './growthEngineHumanPath'

const asTrimmedString = value => {
  if (value == null) return ''
  return String(value).trim()
}

export const GROWTH_ENGINE_STARTER_PRICE_LABEL = '£29/month'
export const GROWTH_ENGINE_MANAGER_FORWARD_LABEL =
  'Forward this to whoever pays'
export const GROWTH_ENGINE_MANAGER_WHATSAPP_SHARE_BASE = 'https://wa.me/'
export const GROWTH_ENGINE_MANAGER_EMAIL_LABEL = 'Email'
export const GROWTH_ENGINE_MANAGER_WHATSAPP_LABEL = 'WhatsApp'

/**
 * @param {object|null|undefined} payload Express guidedSuccess.managerOnePager
 */
export function mapGrowthEngineManagerOnePager(payload) {
  if (!payload || typeof payload !== 'object') return null
  const outcome = asTrimmedString(payload.outcome)
  const forwardLabel = asTrimmedString(payload.forwardLabel)
  if (!outcome || !forwardLabel) return null
  const minutes = Number(payload.estimatedMinutes)
  return {
    forwardLabel,
    starterPriceLabel:
      asTrimmedString(payload.starterPriceLabel) ||
      GROWTH_ENGINE_STARTER_PRICE_LABEL,
    outcome,
    estimatedMinutes: Number.isFinite(minutes) && minutes > 0 ? minutes : null,
    timeSaved: asTrimmedString(payload.timeSaved) || null,
  }
}

/**
 * @param {{
 *   managerOnePager?: object|null,
 *   venueName?: string|null,
 *   plan?: string|null,
 * }} [params]
 * @returns {{
 *   forwardLabel: string,
 *   subject: string,
 *   body: string,
 *   mailtoHref: string,
 *   whatsappHref: string,
 * }|null}
 */
export function buildGrowthEngineManagerOnePagerShare({
  managerOnePager,
  venueName,
  plan,
} = {}) {
  if (isPaidGrowthEnginePlan(plan)) return null
  const pager = mapGrowthEngineManagerOnePager(managerOnePager)
  if (!pager) return null

  const venue = sanitizeGrowthEngineWhatsAppLabel(venueName)
  const timeLine = pager.timeSaved ? `It took ${pager.timeSaved}.` : null
  const starterLine = pager.starterPriceLabel
    ? `Starter is ${pager.starterPriceLabel} if you want the rest of the kitchen on this.`
    : null
  const body = [
    venue || null,
    'I just did this on OMS Lite:',
    pager.outcome,
    timeLine,
    starterLine,
    'I am not the bill payer — can you take a look?',
  ]
    .filter(Boolean)
    .join('\n\n')

  const timeBit = pager.timeSaved ? ` (${pager.timeSaved})` : ''
  const subject = venue
    ? `${venue} — I tried OMS${timeBit}`
    : `I tried OMS${timeBit}`

  const mailtoHref = `mailto:?subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`
  const whatsappHref = `${GROWTH_ENGINE_MANAGER_WHATSAPP_SHARE_BASE}?text=${encodeURIComponent(
    body,
  )}`

  if (
    hasGrowthEngineUpgradeTone(body) ||
    hasGrowthEngineUpgradeTone(subject) ||
    hasGrowthEngineUpgradeTone(pager.forwardLabel)
  ) {
    return null
  }

  return {
    forwardLabel: pager.forwardLabel,
    subject,
    body,
    mailtoHref,
    whatsappHref,
  }
}
